import axios from 'axios'
import {
  Toast
} from 'vant'


let message = ''
const service = axios.create({
  baseUrl: "",

  timeout: 3 * 1000,
  headers: {
    'Content-Type': 'application/json'
  }
})
//请求拦截
service.interceptors.request.use(config => {
  console.log(config)
  config.headers.Authorization = localStorage.getItem('access_token')
  return config
}, error => {
  Promise.reject(error)
})
//响应拦截
service.interceptors.response.use(response => {
  return response
}, error => {
  if (error && error.response) {
    //公共错误处理
    switch (error.response.status) {
      case 400:
        message = "错误请求"
        break;
      case 401:
        message = "未授权，请重新登录"
        break;
      case 403:
        message = "拒绝访问"
        break;
      case 404:
        message = "请求错误，未找到资源"
        //跳转页面
        break;
      case 405:
        message = "请求方法未允许"
        break;
      case 408:
        message = "请求超时"
        break;
      case 500:
        message = "服务器端出错"
        break;
      case 501:
        message = "网络未实现"
        break;
      case 502:
        message = "网络错误"
        break;
      case 503:
        message = "服务不可用"
        break;
      case 504:
        message = "网络超时"
        break;
      case 505:
        message = "http版本不支持请求"
        break;
      default:
        message = `连接错误${error.response.status}`
    }
    Toast(message)
  }

})
export default service
